var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-tabbar',{staticStyle:{"z-index":"999"}},_vm._l((_vm.tablist),function(i,index){return _c('van-tabbar-item',{key:index,class:_vm.actindex==i.link?'TabbarActive':'TabbarUnActive',attrs:{"to":i.link,"info":i.info,"icon":i.icon},on:{"click":function($event){_vm.redirectToMenu(i)}}},[_vm._v(_vm._s(i.name))])}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03fb51f6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer.vue
// module id = null
// module chunks = 